import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { mutationKeyMap } from "@/features/query-client";

import { deleteUser } from "../api";

type ResponseType = Awaited<ReturnType<typeof deleteUser>>;

interface IDeleteUserInput {
  lenderCompanyId: number;
  userId: number;
}

export const useDeleteUserMutation = () => {
  return useMutation<ResponseType, AxiosError, IDeleteUserInput>({
    mutationKey: mutationKeyMap.deleteUser,
    mutationFn: async ({ lenderCompanyId, userId }) => {
      return await deleteUser(lenderCompanyId, userId);
    },
  });
};
